module.exports = __webpack_public_path__ + "media/svg/company-appeal-434744c4.svg";